<template>
  <div class="p-2">
      <div class="device-info vx-col w-full">
          <div class="shadow-drop d-theme-dark-bg cursor-pointer round">
            <vs-avatar class="block" color="danger" icon="notification_important" size="small" v-if="status === true || status === 2"/>
        <vs-avatar class="block" color="#18cd5b" icon="check" size="small" v-else-if="status === false || status === 0"/>
        <vs-avatar class="block" color="#FF9F43" icon="info" size="small" v-else-if="status === 1"/>
          </div>
          <div class="device-text-container">
            <span class="main-info"  v-if="status === true || status === 2">{{message !== undefined ? message :$t("Messages.Alert")}}</span>
            <span class="main-info" v-else-if="status === false || status === 0">{{message !== undefined ? message :$t("Messages.Correct")}}</span>
            <span class="main-info" v-else-if="status === 1">{{message !== undefined ? message :$t("Messages.Correct")}}</span>
            <span class="subtext-info">{{$t("Messages.State")}}</span>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  props: {
    status: {
      type: [Boolean, Number],
      required: true
    },
    message: String
  }
}
</script>
